import type { Adventure } from '../../types'

// Age 4: Number Fun - Number Recognition
export const numberFunAdventure: Adventure = {
  id: 'numbers-1-5',
  title: 'Meet Numbers 1-5',
  theme: 'numbers',
  targetAge: '4',
  difficulty: 'easy',
  estimatedDuration: 6,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hey there, math friend! Today we're going to be number detectives! Can you find the numbers?",
      duration: 5
    },
    story1: {
      id: 'story-1',
      tillyLine: "Numbers are everywhere! This is the number ONE. It looks like a straight line!",
      duration: 5,
      background: 'number-world'
    },
    choice1: [
      {
        id: 'find-one',
        label: 'Find the ONE!',
        tillyLine: "Let's find the number ONE hiding among other numbers!",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'number-recognition',
      question: 'Find the number ONE!',
      tillyPrompt: 'Which one is the number ONE?',
      options: [
        { id: '1', label: '1', isCorrect: true },
        { id: '2', label: '2', isCorrect: false },
        { id: '3', label: '3', isCorrect: false }
      ],
      targetNumber: 1
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Great job! Now let's find the number FIVE. It looks like it has a big belly and a little hat!",
      duration: 5,
      background: 'number-world'
    },
    choice2: [
      {
        id: 'find-five',
        label: 'Find the FIVE!',
        tillyLine: "Can you spot the number FIVE?",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'number-recognition',
      question: 'Find the number FIVE!',
      tillyPrompt: 'Which number is FIVE?',
      options: [
        { id: '3', label: '3', isCorrect: false },
        { id: '4', label: '4', isCorrect: false },
        { id: '5', label: '5', isCorrect: true }
      ],
      targetNumber: 5
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You're a number expert! Now for the SUPER CHALLENGE - find the number THREE!",
        duration: 5,
        background: 'number-world'
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'number-recognition',
          question: 'Find the number THREE!',
          tillyPrompt: 'Which one is the number THREE?',
          options: [
            { id: '2', label: '2', isCorrect: false },
            { id: '3', label: '3', isCorrect: true },
            { id: '4', label: '4', isCorrect: false }
          ],
          targetNumber: 3
        } as any
      ]
    },
    reward: {
      tillyLine: "You found all the numbers! You're officially a Number Detective! Here's your badge!",
      badgeName: 'Number Detective',
      badgeIcon: '🔢',
      nextPreview: 'Next time, we\'ll try some addition!'
    }
  }
}
